export default {
  id: 'shareOnSocialNetwork',
  code: 'CN', 
  text: {
    'Facebook': '脸书分享',
    'Twitter': '推特分享',
    'WeChat': '微信分享',

    'Share on WeChat': '微信分享',
  }  
}



// WEBPACK FOOTER //
// ./src/shared/SocialMediaButton/locale.js